import React from 'react';
import { IconProps } from '../../DefaultIcon';

export function IRSCategoriesIcon({ className }: IconProps) {
  return (
    <svg
      width="87"
      height="83"
      viewBox="0 0 87 83"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1147_2075)">
        <path
          d="M73.5116 83V13.1853C69.54 11.4904 62.4462 3.61411 60.298 0H3.77175C1.69854 0 0 1.69489 0 3.76366V72.9054C0 78.4637 4.5211 83 10.1163 83H73.5116Z"
          fill="#EAEDF8"
        />
        <path
          d="M10.2412 82.9999C15.137 82.9999 19.1585 79.3858 19.808 74.675C19.9079 73.9273 20.5323 73.354 21.3067 73.354H81.5048C82.4539 73.354 83.1783 74.2014 83.0035 75.1237C82.1792 79.6102 78.2326 82.9999 73.5117 82.9999H10.2412Z"
          fill="#00C4B3"
        />
        <path
          d="M36.7432 16.2758H7.66824C7.09373 16.2758 6.61914 15.8022 6.61914 15.229C6.61914 14.6557 7.09373 14.1821 7.66824 14.1821H36.7681C37.3427 14.1821 37.8172 14.6557 37.8172 15.229C37.8172 15.8022 37.3427 16.2758 36.7681 16.2758"
          fill="#00416B"
        />
        <path
          d="M65.8432 24.7255H30.0491C29.4746 24.7255 29 24.252 29 23.6787C29 23.1054 29.4746 22.6318 30.0491 22.6318H65.8432C66.4177 22.6318 66.8923 23.1054 66.8923 23.6787C66.8923 24.252 66.4177 24.7255 65.8432 24.7255Z"
          fill="#00416B"
        />
        <path
          d="M23.3297 24.7255H7.66824C7.09373 24.7255 6.61914 24.252 6.61914 23.6787C6.61914 23.1054 7.09373 22.6318 7.66824 22.6318H23.3297C23.9042 22.6318 24.3788 23.1054 24.3788 23.6787C24.3788 24.252 23.9042 24.7255 23.3297 24.7255Z"
          fill="#00416B"
        />
        <path
          d="M65.8434 33.1752H47.9339C47.3594 33.1752 46.8848 32.7017 46.8848 32.1284C46.8848 31.5551 47.3594 31.0815 47.9339 31.0815H65.8434C66.4179 31.0815 66.8925 31.5551 66.8925 32.1284C66.8925 32.7017 66.4179 33.1752 65.8434 33.1752Z"
          fill="#00416B"
        />
        <path
          d="M41.2143 33.1752H7.66824C7.09373 33.1752 6.61914 32.7017 6.61914 32.1284C6.61914 31.5551 7.09373 31.0815 7.66824 31.0815H41.2393C41.8138 31.0815 42.2884 31.5551 42.2884 32.1284C42.2884 32.7017 41.8138 33.1752 41.2393 33.1752"
          fill="#00416B"
        />
        <path
          d="M65.8436 41.6245H29.5999C29.0254 41.6245 28.5508 41.1509 28.5508 40.5776C28.5508 40.0043 29.0254 39.5308 29.5999 39.5308H65.8436C66.4181 39.5308 66.8927 40.0043 66.8927 40.5776C66.8927 41.1509 66.4181 41.6245 65.8436 41.6245Z"
          fill="#00416B"
        />
        <path
          d="M22.8801 41.6245H7.66824C7.09373 41.6245 6.61914 41.1509 6.61914 40.5776C6.61914 40.0043 7.09373 39.5308 7.66824 39.5308H22.8801C23.4546 39.5308 23.9292 40.0043 23.9292 40.5776C23.9292 41.1509 23.4546 41.6245 22.8801 41.6245Z"
          fill="#00416B"
        />
        <path
          d="M65.8434 50.0493H47.9339C47.3594 50.0493 46.8848 49.5757 46.8848 49.0024C46.8848 48.4291 47.3594 47.9556 47.9339 47.9556H65.8434C66.4179 47.9556 66.8925 48.4291 66.8925 49.0024C66.8925 49.5757 66.4179 50.0493 65.8434 50.0493Z"
          fill="#00416B"
        />
        <path
          d="M35.4193 50.0493H7.66824C7.09373 50.0493 6.61914 49.5757 6.61914 49.0024C6.61914 48.4291 7.09373 47.9556 7.66824 47.9556H35.4443C36.0188 47.9556 36.4934 48.4291 36.4934 49.0024C36.4934 49.5757 35.794 50.0493 35.2195 50.0493"
          fill="#00416B"
        />
        <path
          d="M22.8801 58.499H7.66824C7.09373 58.499 6.61914 58.0254 6.61914 57.4521C6.61914 56.8788 7.09373 56.4053 7.66824 56.4053H22.8801C23.4546 56.4053 23.9292 56.8788 23.9292 57.4521C23.9292 58.0254 23.4546 58.499 22.8801 58.499Z"
          fill="#00416B"
        />
        <path
          d="M65.8434 66.9482H47.9339C47.3594 66.9482 46.8848 66.4746 46.8848 65.9013C46.8848 65.3281 47.3594 64.8545 47.9339 64.8545H65.8434C66.4179 64.8545 66.8925 65.3281 66.8925 65.9013C66.8925 66.4746 66.4179 66.9482 65.8434 66.9482Z"
          fill="#00416B"
        />
        <path
          d="M60.2979 0L73.5115 13.1853H62.3211C61.1971 13.1853 60.2979 12.288 60.2979 11.1664V0Z"
          fill="#00416B"
        />
        <path
          d="M81.1546 47.4321H44.761C41.5329 47.4321 38.916 50.0434 38.916 53.2646V62.7859C38.916 66.007 41.5329 68.6183 44.761 68.6183H81.1546C84.3827 68.6183 86.9996 66.007 86.9996 62.7859V53.2646C86.9996 50.0434 84.3827 47.4321 81.1546 47.4321Z"
          fill="#203E6A"
        />
        <path
          d="M52.1297 50.4976V64.5552H49.457V50.4976H52.1297Z"
          fill="white"
        />
        <path
          d="M59.0487 59.7447H57.1004V64.5552H54.4277V50.4976H59.6482C62.7955 50.4976 64.544 52.5414 64.544 55.1087C64.544 57.003 63.6198 58.5982 61.8713 59.321L64.8937 64.5552H61.8713L59.0737 59.7447H59.0487ZM57.1004 57.2024H59.5733C60.8972 57.2024 61.7464 56.33 61.7464 55.1336C61.7464 53.9372 60.8972 53.0897 59.5733 53.0897H57.1004V57.2024Z"
          fill="white"
        />
        <path
          d="M76.4343 60.4926C76.4343 62.8106 74.8107 64.8046 71.2887 64.8046C68.5411 64.8046 66.0432 63.334 65.6436 61.3151L68.0914 60.3679C68.3412 61.4397 69.5902 62.0878 71.0389 62.0878C72.6625 62.0878 73.5617 61.4397 73.5617 60.5923C73.5617 59.7448 72.8873 59.3959 70.5893 58.698C67.3421 57.7259 66.0182 56.5046 66.0182 54.4358C66.0182 52.5914 67.3671 50.373 70.9889 50.373C73.1371 50.373 75.3352 51.5196 75.7349 53.5385L73.3619 54.4109C73.1871 53.5385 72.038 53.04 71.0139 53.0151C69.8899 53.0151 68.8658 53.389 68.8658 54.3112C68.8658 54.9842 69.3903 55.383 71.6134 56.0809C74.386 56.9283 76.4343 57.8505 76.4343 60.4676V60.4926Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1147_2075">
          <rect width="87" height="83" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
